export const FrequencyTypeIds = {
  RepeatEvery: 2,
} as const;
